import * as React from "react";
import { singleton } from "logic/singleton";
export const DEFAULT_EXTERNAL_ACTIONS = {
  isLoading: false,
  externalValueActions: [],
  isError: false
};
const ExternalValueActionsContext = React.createContext(DEFAULT_EXTERNAL_ACTIONS);
export default singleton("contexts.ExternalValueActionsContext", () => ExternalValueActionsContext);
